import { render, staticRenderFns } from "./sms_bill.vue?vue&type=template&id=04bc5480&scoped=true"
import script from "./sms_bill.vue?vue&type=script&lang=js"
export * from "./sms_bill.vue?vue&type=script&lang=js"
import style0 from "./sms_bill.vue?vue&type=style&index=0&id=04bc5480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bc5480",
  null
  
)

export default component.exports